module.exports = { 
  SPRING_APP_ID : "37480D40-8F3F-46AA-8693-7EF507D1B60E",
  CEDELE_APP_ID : "DB72C391-60BA-4176-8AB0-5CA0FEBC7BD1",
  PIE_APP_ID : "389C7769-7311-48D1-8FC3-C8B7BE1D3BC6",
 }